export default function setSearchReferencesDataAction(referencesData) {
    return {
        type: 'SET_SEARCH_REFERENCES_DATA',
        payload: referencesData
    }
}